export class LocalStorageConstants {
    static idGradoHeader = 'selectedGradoHeader';
    static tipoEntitaHeader = 'tipoEntitaHeader';
    static idEntitaHeader = 'idEntitaHeader';
}
